import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import ReviewLine from '../components/ReviewLine'
import { selectors as PaymentSelectors } from 'data/payment'

import { Button, Text } from 'components/base'

import ErrorMessage from '../components/ErrorMessage'

import providesOrganizationPaymentInfos from '../../dataSync/providesOrganizationPaymentInfos'
import providesUpdateDetails from '../dataSync/providesUpdateDetails'
import providesUpdateCard from '../dataSync/providesUpdateCard'

import Modal from './Modal'
import UpdateDetailsForm from './UpdateDetailsForm'
import UpdateCardForm from './UpdateCardForm'

class SettingsBillingInformations extends Component {
  state = {
    openModal: null,
    updateDetailsLoading: false,
    updateCardLoading: false,
    updateCardError: null,
  }

  render() {
    if (this.props.paymentInfoFetchState.error) {
      return (
        <ErrorMessage
          retry={this.props.forceQuery}
          action="getting your billing information"
          message={this.props.paymentInfoFetchState.error.message}
        />
      )
    }

    if (
      this.props.paymentInfoFetchState.loading ||
      this.props.paymentInfoFetchState.pristine
    ) {
      return <div>Loading your billing information...</div>
    }

    return (
      <div className="slite-design-system">
        <Modal
          isOpen={Boolean(this.state.openModal)}
          onModalClose={this.closeModal}
        >
          {this.renderModal()}
        </Modal>
        <div className="flexbox flexbox-space-between width-full  margin-top-largest margin-bottom-medium">
          <Text.Subtitle>Company information</Text.Subtitle>
          <Button.Primary onClick={this.openUpdateDetailsModal}>
            Update information
          </Button.Primary>
        </div>
        <ReviewLine label="Company name">
          {this.props.paymentInfos.addressName}
        </ReviewLine>
        <ReviewLine label="VAT ID">{this.props.paymentInfos.vatId}</ReviewLine>
        <ReviewLine label="Address">
          <div>{this.props.paymentInfos.addressLine1}</div>
          <div>{this.props.paymentInfos.addressLine2}</div>
          <div>
            {[
              this.props.paymentInfos.addressPostalCode,
              this.props.paymentInfos.addressCity,
              this.props.paymentInfos.addressState,
            ]
              .filter(x => x)
              .join(', ')}
          </div>
          <div>{this.props.paymentInfos.addressCity}</div>
        </ReviewLine>
        <ReviewLine label="Email">
          {this.props.paymentInfos.billingEmail}
        </ReviewLine>

        <div className="flexbox flexbox-space-between width-full  margin-top-largest margin-bottom-medium">
          <Text.Subtitle>Payment method</Text.Subtitle>
          <Button.Primary onClick={this.openUpdateCardModal}>
            Update payment
          </Button.Primary>
        </div>
        <ReviewLine
          label="Credit card"
          childrenClassName="flexbox flexbox-space-between width-full"
        >
          <div>**** **** **** {this.props.paymentInfos.last4}</div>
          <div>{this.props.paymentInfos.cardBrand}</div>
          <div>
            Expire: {this.props.paymentInfos.cardExpMonth}/
            {this.props.paymentInfos.cardExpYear}
          </div>
        </ReviewLine>
      </div>
    )
  }
  closeModal = () => {
    this.setState({ openModal: null })
  }

  openUpdateDetailsModal = () => this.setState({ openModal: 'details' })
  openUpdateCardModal = () => this.setState({ openModal: 'card' })

  renderModal() {
    switch (this.state.openModal) {
      case null:
        return null
      case 'details':
        return (
          <UpdateDetailsForm
            paymentInfos={this.props.paymentInfos}
            onCancel={this.closeModal}
            onSave={this.onSaveDetails}
            loading={this.state.updateDetailsLoading}
          />
        )
      case 'card':
        return (
          <UpdateCardForm
            paymentInfos={this.props.paymentInfos}
            onCardChange={this.onCardChange}
            onCancel={this.closeModal}
            onSave={this.onSaveCard}
            error={this.state.updateCardError}
            loading={this.state.updateCardLoading}
          />
        )
      default:
        throw new Error(`Unknown modal name ${this.state.openModal}`)
    }
  }

  onSaveDetails = paymentInfos => {
    this.setState({ updateDetailsLoading: true })
    this.props.updateBillingDetails({ input: paymentInfos }).then(() => {
      this.setState({
        openModal: null,
        updateDetailsLoading: false,
      })
    })
  }

  onCardChange = card => {
    this.setState({
      updateCardError: null,
    })
  }

  onSaveCard = token => {
    this.setState({ updateCardLoading: true })
    this.props.updateBillingCard({ input: { token } }).then(
      () => {
        this.setState({
          openModal: null,
          updateCardLoading: false,
          updateCardError: null,
        })
      },
      ({ error }) => {
        this.setState({
          updateCardLoading: false,
          updateCardError: error,
        })
      }
    )
  }
}

export default compose(
  providesOrganizationPaymentInfos,
  providesUpdateDetails,
  providesUpdateCard,
  connect(state => ({
    paymentInfos: PaymentSelectors.getOrganizationPaymentInfos(state),
  }))
)(SettingsBillingInformations)
